// Global JS configurations.
var SMF = {
    MAX_WIDTH_CONTENT: 940,
};
window.SMF = SMF;

// prefill picture element
document.createElement( "picture" );

// Global variables
var lastScrollTop;

/**
 * Ready Function
 * --------------------------------------------------------------------------------------------------
 * The '$' is set to '$' here
 */

$(document).ready(function($) {

    // Set initial state

    lastScrollTop = $(this).scrollTop();

    // Setup vendor scripts

    $('.testimonials-slider').slick({
        dots: false,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        infinite: false,
        variableWidth: true
    });

    $('.product-slider').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true
    });

    $('.suggested-products-slider').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true
    });

    $('.customers-slider').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true
    });

    $('.additional-product-slider .slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    variableWidth: true
                }
            }
        ]
    });

    $('.awards-slider-short').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        infinite: false
    });

    $('.stage-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        autoplaySpeed: 4000
    });

    $('.lightbox').fancybox({
        width: 920,
        openEffect: 'fade',
        closeEffect: 'fade',
        wrapCSS: 'lightbox',
        helpers: {
            overlay: {
                css: {
                    "background-color": "rgba(0, 0, 0, 0.5)"
                }
            }
        },
        beforeLoad: function() {
            if ($(window).width() <= SMF.MAX_WIDTH_CONTENT * 0.6) {
                return false;
            }
        }
    });

    $('.popup').fancybox({
        maxWidth: 760,
        height: 'auto',
        openEffect: 'fade',
        closeEffect: 'fade',
        wrapCSS: 'popup',
        arrows: false,
        helpers: {
            overlay: {
                css: {
                    "background-color": "rgba(0, 0, 0, 0.5)"
                }
            }
        }
    });

    $('.popup-video').fancybox({
        height: 'auto',
        padding: [0, 0, 0, 0],
        openEffect: 'fade',
        closeEffect: 'fade',
        wrapCSS: 'popup',
        helpers: {
            overlay: {
                css: {
                    "background-color": "rgba(0, 0, 0, 0.8)"
                }
            }
        }
    });

    $('img[usemap]').rwdImageMaps();

    window.replaceImageForMap = function(filename){
        document.getElementById('imagemap').setAttribute("src", filename);
    };

    // Initialize modules
    VideoPlayer.init();
    Tabs.init();
    Menu.init();
    Accordion.init();
    ChoiceLoader.init();
    GridSlide.init($('#product-choice-gridslide'));
    GridSlide.init($('#news-teaser-gridslide'), "980px");
    GridSlide.initProductFamilies($('.product-families__wrapper--stage'), $('.product-families__wrapper--info'));
    PerspectivePreview.init();
    Form.init();
    ScrollUpButton.init();
    NewsletterTeaser.init();
    LikeBox.init();
    ProductGallery.init();
    NetPrice.init();
    Stage.init(); // must be initialized after slick slider
    BuyBox.init(); // must be initialized after slick slider

    // Add event listeners

    window.addEventListener('resize', resizeAware, false);
});

/**
 * Event Handlers
 * --------------------------------------------------------------------------------------------------
 */

/**
 * Handle resize event
 */

function resizeAware() {
    // (Re-)Initialize modules (that depend on viewport size)
    GridSlide.init($('#product-choice-gridslide'));
    GridSlide.init($('#news-teaser-gridslide'), "980px");
    GridSlide.initProductFamilies($('.product-families__wrapper--stage'), $('.product-families__wrapper--info'));
}
